'use client';
import React from 'react';
import PropTypes from 'prop-types';
import { VisuallyHidden } from '@web/atoms';
import { useReporter } from '../../../reporter';
import { ResponsiveImage } from '../../ResponsiveImage';
import fallbackLogo from './ollie-logo.svg';
import {
  StyledNavigationBar,
  OllieLogo,
  LogoImgContainer,
  CenterAligned,
  LeftAligned,
  RightAligned,
  SkipToContent,
  LogoLink,
} from './styles.js';
import { logoClicked } from './events';

export const NavigationBar = ({
  logoImg,
  logoUrl = '/',
  logoSrText = 'Ollie home',
  leftSegment,
  centerSegment,
  rightSegment,
  bgColor = 'background.dark',
  fontColor = 'text.lighter',
  showLogo = true,
  verticalPadding = 6,
  horizontalPadding = 6,
}) => {
  const reporter = useReporter();
  const onLogoClick = () => {
    reporter.tag(logoClicked(window.location.pathname));
  };

  const hasCenterLinks = !(centerSegment === undefined);

  return (
    <StyledNavigationBar
      $bgColor={bgColor}
      $fontColor={fontColor}
      role="navigation"
      showLogo={showLogo}
      $verticalPadding={verticalPadding}
      $horizontalPadding={horizontalPadding}
    >
      <SkipToContent href="#main">Skip to Content</SkipToContent>
      {/* Optional: left segment of nav (i.e: burger menu) */}
      <LeftAligned>{leftSegment}</LeftAligned>
      {showLogo && (
        <OllieLogo $hasCenterLinks={hasCenterLinks}>
          <LogoLink href={logoUrl} onClick={onLogoClick}>
            <LogoImgContainer>
              <ResponsiveImage
                {...(logoImg ?? fallbackLogo)}
                alt="Ollie logo"
              />
            </LogoImgContainer>
            <VisuallyHidden>{logoSrText}</VisuallyHidden>
          </LogoLink>
        </OllieLogo>
      )}
      {/* Optional: this is always the middle segment of the nav */}
      <CenterAligned $hasCenterLinks={hasCenterLinks}>
        {centerSegment}
      </CenterAligned>
      {/* Optional: right segment of nav (i.e: cart icon, login) */}
      <RightAligned>{rightSegment}</RightAligned>
    </StyledNavigationBar>
  );
};

NavigationBar.propTypes = {
  bgColor: PropTypes.string,
  fontColor: PropTypes.string,
  logoImg: PropTypes.object,
  logoUrl: PropTypes.string,
  logoSrText: PropTypes.string,
  leftSegment: PropTypes.node,
  centerSegment: PropTypes.node,
  rightSegment: PropTypes.node,
  showLogo: PropTypes.bool,
  verticalPadding: PropTypes.number,
};
